window.loadAreaSnapshot = function() {
    var colors = [
        '#FFEBCD', '#DB7093', '#800000', '#483D8B', '#FA8072', '#32CD32', '#008080', '#ADD8E6', '#DDA0DD', '#F0FFF0', '#808080', '#FFEBCD', '#CD5C5C', '#FFA500', '#FFDAB9',
        '#3CB371', '#5F9EA0', '#00008B', '#800080', '#FFF5EE', '#2F4F4F'];

    var ptColors = [
        '#D94B9A', '#F98240', '#17D7E4', '#504FAF', '#FC636C', '#434342', '#FFC400', '#800000', '#008080', '#001717', '#FFD89E'
    ];

    $('.stat-circle').each(function () {
        var circleStatText = '';
        var percent;
        var fillColor;
        var fontColor;
        if ($(this).data('index-percent') > 0) {
            circleStatText = 'Higher';
            percent = parseFloat($(this).data('index-percent')).toFixed(1);
            fillColor = '#D75452';
            fontColor = '#D75452';
        } else if ($(this).data('index-percent') <= 0) {
            circleStatText = 'Lower';
            percent = parseFloat($(this).data('index-percent')).toFixed(1);
            fillColor = '#33B17C';
            fontColor = '#33B17C';
        }
        $(this).circliful({
            text: circleStatText,
            percent: Math.abs(percent),
            description: $(this).data('nh-label'),
            foregroundColor: fillColor,
            fontColor: fontColor,
            animation: 0,
            animateInView: 0,
            animationStep: 2,
            textY: 120,
            textX: 100,
            percentageY: 100
        });
    });

    var employeeChart = $("#employeeChart");
    var dataEmployeeData = [];
    var dataEmployeeLabel = [];
    var employeeData = employeeChart.data('employees');
    Object.keys(employeeData).forEach(function(key,index) {
        dataEmployeeLabel.push(key);
        dataEmployeeData.push(employeeData[key]);
    });
    //console.log(employeeData);
    var employeeDoughnutChart = new Chart(employeeChart, {
        type: 'doughnut',
        data: {
            datasets: [{
                data: dataEmployeeData,
                backgroundColor: colors
            }],

            // These labels appear in the legend and in the tooltips when hovering different arcs
            labels: dataEmployeeLabel
        },
        options: {
            responsive: true,
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 10
                }
            },
            title: {
                display: true,
                text: 'Percent of employment by industry sector'
            },
            animation: {
                animateScale: true,
                animateRotate: true
            }
        }
    });

    var salesChart = $("#salesChart");
    var dataSalesData = [];
    var dataPropertyTypeLabel = [];
    var salesData = salesChart.data('sales');
    if(salesData){
        salesData.forEach(function(key) {
            dataPropertyTypeLabel.push(key.readable);
            dataSalesData.push(key.count);
        });
        //console.log(employeeData);
        var salesDoughnutChart = new Chart(salesChart, {
            type: 'doughnut',
            data: {
                datasets: [{
                    data: dataSalesData,
                    backgroundColor: colors
                }],

                // These labels appear in the legend and in the tooltips when hovering different arcs
                labels: dataPropertyTypeLabel
            },
            options: {
                responsive: true,
                legend: {
                    position: 'bottom',
                    labels: {
                        boxWidth: 10
                    }
                },
                title: {
                    display: true,
                    text: '180 Day Sales by Property Type'
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            }
        });
    }
};


if($('#propertiesGallery').length) {
    $('.owl-carousel').owlCarousel({
        center: true,
        smartSpeed: 500,
        items:3,
        loop:true,
        autoplay:true,
        autoplayHoverPause:true,
        nav:true,
        margin:10,
        responsive:{
            0: {
                items:1
            },
            480:{
                items:1
            },
            768:{
                items:1,
                autoWidth:true
            },
            993:{
                items:1,
                autoWidth:true
            }
        }
    });
}

if($('.valuation-input').length) {
    var valuationGroups = $('.valuation-input-group');
    valuationGroups.each(function () {
        var width = $(this).parent().width();
        if (width < 450) {
            $(this).find('#locationFieldWrapper').removeClass('col-sm-9');
            $(this).find('#unitFieldWrapper').removeClass('col-sm-3');
        }
        //console.log(width);
    });
}

function initScript() {
    if($('#details-map').length){
        var listing = $('.propertyTarget');
        var latlng = {lat: parseFloat(listing.attr('data-latitude')), lng: parseFloat(listing.attr('data-longitude'))};
        // Create a map object and specify the DOM element for display.
        var map = new google.maps.Map(document.getElementById('details-map'), {
            center: latlng,
            scrollwheel: false,
            zoom: 15
        });

        var marker = new google.maps.Marker({
            position: latlng,
            map: map
        });
    }

    if($('.valuation-input').length){

        // Create the autocomplete object, restricting the search to geographical
        // location types.
        if($('#autocomplete').length){
            autocomplete = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(document.getElementById('autocomplete')),
                {types: ['geocode']});

            // When the user selects an address from the dropdown, populate the address
            // fields in the form.
            autocomplete.addListener('place_changed', fillInAddress);
        }
    }
}

// This example displays an address form, using the autocomplete feature
// of the Google Places API to help users fill in the information.

// This example requires the Places library. Include the libraries=places
// parameter when you first load the API. For example:
// <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">

var placeSearch, autocomplete;
var componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
};

function fillInAddress() {
    // Get the place details from the autocomplete object.
    var place = autocomplete.getPlace();

    for (var component in componentForm) {
        document.getElementById(component).value = '';
        document.getElementById(component).disabled = false;
    }

    // Get each component of the address from the place details
    // and fill the corresponding field on the form.
    for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
            var val = place.address_components[i][componentForm[addressType]];
            document.getElementById(addressType).value = val;
        }
    }

    $('#valuationLatitude').val(place.geometry.location.lat());
    $('#valuationLongitude').val(place.geometry.location.lng());

    $('#stepOneButton').removeAttr('disabled');
}

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
function geolocate() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
            var geolocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            var circle = new google.maps.Circle({
                center: geolocation,
                radius: position.coords.accuracy
            });
            autocomplete.setBounds(circle.getBounds());
        });
    }
}

function validateHomeValueInputs(){
    var form = $('#stepTwoFormRequired input');
    if(form.length){
        //console.log(form);
        form.each(function(){
            $(this).keyup(function(){
                checkFilledfields();
            })
        })
    }
}

function checkFilledfields(){
    var submitButton = $('#stepTwoButton');
    var formFields = $('#stepTwoFormRequired');
    var empty = formFields.find('input').filter(function(){
        return this.value === "";
    });
    if(empty.length) {
        submitButton.attr('disabled', 'disabled');
    } else {
        submitButton.removeAttr('disabled');
    }
}

$(document).ready(function(){
    var activeSchoolsTable = $('#schoolsTable');
    if(activeSchoolsTable.length){
        activeSchoolsTable.DataTable();
    }

    if($('#stepTwoForm').length){
        validateHomeValueInputs();
    }

    if($('.Community__data').length){
        loadAreaSnapshot();
        $('#highSchools').addClass('active');
        var currentSlider = $('#highSchools').slick({
            vertical: true,
            slidesToShow: 5,
            slidesToScroll: 4,
            infinite: false,
            prevArrow: $('.schoolUp'),
            nextArrow: $('.schoolDown'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
        $('.school-targets .type-count').click(function(){
            if(!$(this).hasClass('active')){
                var clicked = $(this);
                $('.type-count').removeClass('active');
                clicked.addClass('active');
                $('.schools-table-section').removeClass('active');
                $('#' + clicked.data('school-target')).addClass('active');
                currentSlider.slick('unslick');
                currentSlider = $('#' + clicked.data('school-target')).slick({
                    vertical: true,
                    slidesToShow: 5,
                    slidesToScroll: 4,
                    infinite: false,
                    prevArrow: $('.schoolUp'),
                    nextArrow: $('.schoolDown'),
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3

                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        }
                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object
                    ]
                });
            }
        })
    }


});
